<template>
  <div>
    <approve-list :key="flag" :title="title" :type="flag"></approve-list>
  </div>
</template>

<script>
import ApproveList from '../component/approveList';

export default {
  name: 'EnquireApprove',

  components: {
    ApproveList,
  },
  data() {
    return {
      title: '公告审批',
      flag: 8,
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
